import styled from "styled-components";
import { Icon, ICON_SIZES } from "./Icon";

import { colors } from "@permisso/permisso-components";

interface IconButtonProps {
  size: ICON_SIZES;
  color: string;
  path: React.ReactNode;
  onClick: () => void;
  className?: string;
}

export const IconButton = ({ size, color, path, onClick, className }: IconButtonProps) => {
  return (
    <ButtonContainer className={className} onClick={onClick}>
      <Icon size={size} color={color} path={path} />
    </ButtonContainer>
  );
};

const ButtonContainer = styled.div`
  padding: 0.625rem;
  align-self: stretch;
  border-radius: 0.375rem;
  gap: 0.0625rem;
  &:hover {
    cursor: pointer;
    background-color: ${colors.grey300};
  }
`;
